import React from "react";
import { Controller } from "react-hook-form";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import { Box, Typography } from "@mui/material";
export default function FormTelInput({
  fieldname,
  control,
  label,
  required = false,
  rules,
}) {
  // Combine required and phone validation rules
  const validationRules = {
    ...rules,
    ...(required && { required: "This field is required" }),
    validate: (value) =>
      matchIsValidTel(value) || "Please enter a valid phone number",
  };
  return (
    <Controller
      defaultValue={""}
      name={fieldname}
      control={control}
      rules={validationRules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Box>
          <Typography variant="body1" textAlign={"left"}>
            {label} {required && <span style={{ color: "red" }}>*</span>}
          </Typography>
          <MuiTelInput
            fullWidth
            helperText={error?.message}
            error={!!error}
            defaultCountry="PK"
            value={value}
            // label={label}
            size={"small"}
            onChange={onChange}
          />
        </Box>
      )}
    />
  );
}
